import { render, staticRenderFns } from "./MatchItem.vue?vue&type=template&id=127bd246&"
import script from "./MatchItem.vue?vue&type=script&lang=js&"
export * from "./MatchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127bd246')) {
      api.createRecord('127bd246', component.options)
    } else {
      api.reload('127bd246', component.options)
    }
    module.hot.accept("./MatchItem.vue?vue&type=template&id=127bd246&", function () {
      api.rerender('127bd246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/financial/reconciliation/getnet/components/MatchItem.vue"
export default component.exports